import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
var _excluded = ["children", "style", "className", "sx", "sy", "spacing", "Container"];

var _context, _context2;

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { forwardRef, useMemo } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { omit } from 'lodash';
var flexTypes = ['flexDirection', 'flexWrap', 'alignItems', 'alignContent', 'alignSelf', 'justifyContent', 'justifySelf', 'flexShrink', 'flex', 'flexAuto', 'flexNone'];
var aliases = {
  p: 'padding',
  pt: 'paddingTop',
  pr: 'paddingRight',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  m: 'margin',
  mt: 'marginTop',
  mr: 'marginRight',
  mb: 'marginBottom',
  ml: 'marginLeft',
  width: 'width',
  height: 'height',
  w: 'width',
  h: 'height'
};

var flexProps = _Object$values(flexTypes);

var spacingProps = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(_Object$keys(aliases)), _toConsumableArray(_Object$values(aliases)));

var styleProps = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(flexProps), _toConsumableArray(spacingProps));

var layoutProps = ['sx', 'sy', 'spacing'];

function getStyles(x, y) {
  return StyleSheet({
    container: {
      boxSizing: 'border-box'
    },
    spacingX: {
      marginLeft: "calc(-".concat(x, "/2)"),
      marginRight: "calc(-".concat(x, "/2)"),
      '& > *': {
        marginLeft: "calc(".concat(x, "/2)"),
        marginRight: "calc(".concat(x, "/2)")
      }
    },
    spacingY: {
      marginTop: "calc(-".concat(y, "/2)"),
      marginBottom: "calc(-".concat(y, "/2)"),
      '& > *': {
        marginTop: "calc(".concat(y, "/2)"),
        marginBottom: "calc(".concat(y, "/2)")
      }
    }
  });
}

var displayName = 'Box';
/**
 * Box is a layout helper to make managing the structure of pages easier and more consistent
 */

export var Box = /*#__PURE__*/forwardRef(function Box(_ref, ref) {
  var children = _ref.children,
      style = _ref.style,
      className = _ref.className,
      sx = _ref.sx,
      sy = _ref.sy,
      spacing = _ref.spacing,
      _ref$Container = _ref.Container,
      Container = _ref$Container === void 0 ? 'div' : _ref$Container,
      rest = _objectWithoutProperties(_ref, _excluded);

  var defaultStyles = useMemo(function () {
    var x = sx || spacing;
    var y = sy || spacing;

    if (typeof x !== 'string') {
      x = "".concat(x, "px");
    }

    if (typeof y !== 'string') {
      y = "".concat(y, "px");
    }

    return getStyles(x, y);
  }, [sx, sy, spacing]);
  var s = useStyles(defaultStyles, displayName);
  var cleanProps = useMemo(function () {
    var _context3;

    return omit(rest, _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(styleProps), layoutProps));
  }, [rest]);
  var isFlex = useMemo(function () {
    return !!_findInstanceProperty(flexProps).call(flexProps, function (flexType) {
      return rest[flexType];
    });
  }, [rest]);
  var mapStyles = useMemo(function () {
    var base = isFlex ? {
      display: 'flex'
    } : {};
    return _reduceInstanceProperty(styleProps).call(styleProps, function (acc, propName) {
      var prop = rest[propName];

      if (!prop) {
        return acc;
      }

      var value = prop;
      if (!value) return acc;
      var name = aliases[propName] || propName;
      acc[name] = value;
      return acc;
    }, base);
  }, [isFlex, rest]);
  return /*#__PURE__*/React.createElement(Container, _extends({}, cleanProps, s.with('container', {
    spacingX: !!(sx || spacing),
    spacingY: !!(sy || spacing)
  })(_objectSpread({
    style: style,
    className: className
  }, mapStyles)), {
    ref: ref
  }), children);
});
export default Box;